// ** Initial State
const initialState = {
  leadBoardLeadCount : 0,
  products: [],
  productsLoading: false,
  hasFetchedProducts: false,
  leadProducts: {},
  customFiltersList: [],
  hasFetchedCustomFilters: false,
  leadStatusArray: [],
  hasFetchedLeadStatuses: false
}

const leadBoardReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_LEADBOARD_LEAD_COUNT':
      return { ...state, leadBoardLeadCount: action.count }
    case 'GET_PRODUCTS_REQUEST':
      return { ...state, productsLoading: true }
    case 'GET_PRODUCTS_SUCCESS':
      return { ...state, productsLoading: false, products: action.payload, hasFetchedProducts: true }
    case 'GET_PRODUCTS_FAILURE':
      return { ...state, productsLoading: false, hasFetchedProducts: true } // still mark fetched to avoid infinite retries
    case 'ADD_PRODUCT_SUCCESS':
      return { ...state, products: [...state.products, action.payload] }
    case 'UPSERT_LEAD_PRODUCT':
      return { ...state, leadProducts: { ...state.leadProducts, [action.payload.leadId]: action.payload.productId } }
    case 'GET_CUSTOM_FILTERS_SUCCESS':
      return { ...state, customFiltersList: action.payload, hasFetchedCustomFilters: true }
    case 'GET_LEAD_STATUS_SUCCESS':
      return { ...state, leadStatusArray: action.payload, hasFetchedLeadStatuses: true }
    case 'REFRESH_CUSTOM_FILTERS':
      return { ...state, customFiltersList: action.payload }
    default:
      return state
  }
}

export default leadBoardReducer
